import miradorDownloadPlugin from './miradorDownloadPlugin';
import miradorDownloadDialogPlugin from './MiradorDownloadDialog';

export { miradorDownloadPlugin, miradorDownloadDialogPlugin };

export default [miradorDownloadPlugin, miradorDownloadDialogPlugin];
